<template>
  <section class="bestselling">
    <h2 class="billing-data__title">
      Bestselling Authors Rave About Shortform!
    </h2>
    <Blockquotes content="partners" />
  </section>
</template>

<script setup lang="ts">
import Blockquotes from '@/components/public/Blockquotes.vue'
// @ts-ignore
import { testimonials } from '@/assets.v2/js/pagesSite.js'
import { onMounted } from 'vue'

onMounted(() => {
  testimonials()
})
</script>

<style scoped lang="scss">
.bestselling {
  :deep(.blockquote-slider) {
    margin-bottom: 0;
    margin-top: 32px;
    padding-bottom: 32px;

    @media (max-width: $w-tablet-s) {
      margin-top: 28px;
    }
  }

  :deep(.blockquote) {
    margin-bottom: 60px;
  }
  margin-bottom: 0;
}

.night-mode {
  .bestselling {
    :deep(.blockquote-slider::before) {
      background: url(@/assets.app/images/billing/quote-dark.svg) center
        no-repeat;
      background-size: contain;
    }
    :deep(.blockquote-slider__text) {
      color: $c-black-11;
    }
    :deep(.active .blockquote-people-slider__name) {
      color: $c-white;
    }

    :deep(.blockquote-people-slider__mobile-button.active) {
      background: $c-white;
    }
    :deep(.blockquote-people-slider__subtitle) {
      color: $c-black-6;
    }

    :deep(.blockquote-people-slider__box) {
      &:before {
        background: $c-white;
      }
    }

    :deep(.blockquote-people-slider__item) {
      @include hover {
        .blockquote-people-slider__name {
          color: $c-white;
        }
      }
    }

    :deep(.blockquote-people) {
      border-color: $c-border-6;
    }
  }
}
</style>
